import Vue from 'vue';
import webcall from '@/libs/webcall';
import camelCase from 'lodash/camelCase';

import legacySpecification from './legacySpecification';

// Instruction maker
const makeInstruction = (path, data) => ({
  path,
  data,
});

const extractItem = (itemNode) => {
  const itemType = itemNode.dataset.itemType || itemNode.className;
  const itemComponent = itemType === 'component'
    ? {
      componentName: itemNode.dataset.componentName,
    } : null;

  const itemAction = itemType === 'action'
    ? {
      inputName: itemNode.dataset.inputName,
      inputType: itemNode.dataset.inputType,
      inputValue: itemNode.dataset.inputValue,
      inputValuePrefilled: itemNode.dataset.inputValuePrefilled,
      inputValueDeselect: itemNode.dataset.inputValueDeselect,
    } : null;

  return ({
    itemType,
    itemAction,
    itemComponent,
    itemHTML: itemNode.innerHTML,
  });
};

const extractItems = (htmlNode) => {
  const title = (htmlNode.querySelector('.title') || {}).textContent;
  const itemNodes = htmlNode.querySelectorAll('.content, .action, .component');

  // Prepare result
  return {
    title,
    itemFormName: htmlNode.dataset.formName,
    optional: !!htmlNode.dataset.optional,
    items: [...itemNodes]
      .reduce((acc, itemNode) => {
        acc.push(extractItem(itemNode));
        return acc;
      }, []),
  };
};


// Result array of object containing path and data
const processor = {
  specification(data) {
    try {
      const rawSpecification = JSON.parse(data.innerHTML);
      const specification = Object.keys(rawSpecification)
        .reduce((acc, agreementName) => {
          const specificationItem = rawSpecification[agreementName];
          acc[agreementName] = {
            title: specificationItem.title,
            sequence: specificationItem.sequence.map(camelCase),
          };
          return acc;
        }, {});

      return [
        makeInstruction('specification', specification),
      ];
    } catch (error) {
      return [
        makeInstruction('specification', null),
      ];
    }
  },
  license(data) {
    return data.map((htmlNode) => {
      const licenseName = camelCase(htmlNode.dataset.license);
      return makeInstruction(`license.${licenseName}`, extractItems(htmlNode));
    });
  },
  action(data) {
    return data.map((htmlNode) => {
      const actionName = camelCase(htmlNode.dataset.action);
      return makeInstruction(`action.${actionName}`, extractItems(htmlNode));
    });
  },
};

const agreement = {
  namespaced: true,
  state: {
    hasError: false,
    specification: null,
    license: {},
    action: {},
  },
  mutations: {
    update(state, { path, data }) {
      const subPath = path.split('.');

      if (subPath.length === 1) {
        Vue.set(state, path, data);
      } else {
        Vue.set(state[subPath[0]], subPath[1], data);
      }
    },
    declareError(state) {
      state.hasError = true;
    },
  },
  actions: {
    initialise({ state, commit, rootState }) {
      webcall.agreement.get()
        // Obtain data remotely
        .then(({ data }) => {
          const agreementHTMLString = data.terms;
          return agreementHTMLString;
        })
        // Filter data according to source
        .then((htmlString) => {
          const parser = new DOMParser();
          const agreementDoc = parser.parseFromString(htmlString, 'text/html');
          const nodes = {
            license: [...agreementDoc.querySelectorAll('[data-license]')],
            action: [...agreementDoc.querySelectorAll('[data-action]')],
            specification: agreementDoc.querySelector('[data-specification]'),
          };

          return nodes;
        })
        // Process each source
        .then(nodes => Object.entries(nodes)
          .map(([key, value]) => processor[key](value))
        )
        .then((results) => {
          const specificationData = results[2][0].data;
          if (!specificationData) {
            return legacySpecification.makeCompatible(results);
          }
          return results;
        })
        // Commit results
        .then((results) => {
          results.forEach((result) => {
            result.forEach((instruction) => {
              commit('update', instruction);
            });
          });
        })
        .catch((error) => {
          commit('declareError');
          throw error;
        });
    },
  },
};

export default agreement;



// WEBPACK FOOTER //
// ./src/store/modules/agreement/index.js